<template>
  <div class="form-support-v2">
    <validation-observer ref="validator" v-slot="{ handleSubmit }">
      <v-card-text class="px-6" :style="mobileStyle">
        <v-row>
          <v-col cols="12" md="12" sm="12">
            <validation-provider
              v-slot="{ errors }"
              class="mb-3"
              :rules="{ regex: regex.isCustomerCode, required: true }"
              name="Mã Khách hàng"
            >
              <v-text-field
                v-model="dataForm.customerCode"
                label="Mã khách hàng *"
                :error-messages="errors"
                color="primary"
                placeholder="Mã khách hàng"
                clearable
                :maxlength="limitLangeCustomerCode"
                @input="clearSpace"
                @change="clearSpace"
                @keydown.space.prevent
              >
                <template slot="label">
                  <div>Mã khách hàng <span style="color: red">*</span></div>
                </template>
              </v-text-field>
            </validation-provider>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" sm="12">
            <validation-provider
              v-slot="{ errors }"
              class="mb-3"
              name="Chọn nhóm ticket"
              :rules="{ required: true }"
            >
              <v-autocomplete
                v-model="dataForm.ticketGroupId"
                attach
                :items="groupTickes"
                :error-messages="errors"
                label="Tùy chọn hỗ trợ *"
                color="primary"
                placeholder="Chọn ticket cha"
                item-text="name"
                item-value="id"
                clearable
                :return-object="true"
                @change="onChangeTicketGroup"
              >
                <template slot="label">
                  <div>Chọn nhóm Ticket <span style="color: red">*</span></div>
                </template>
              </v-autocomplete>
            </validation-provider>
          </v-col>
          <v-col cols="12" md="6" sm="12">
            <validation-provider
              v-slot="{ errors }"
              class="mb-3"
              name="Chọn loại ticket"
              :rules="{ required: true }"
            >
              <v-autocomplete
                v-model="dataForm.ticketTypeId"
                attach
                :items="ticketTypeNames"
                :error-messages="errors"
                label="Tùy chọn hỗ trợ *"
                color="primary"
                placeholder="Chọn ticket con"
                item-text="ticketTypeName"
                item-value="ticketTypeId"
                clearable
                :return-object="true"
              >
                <template slot="label">
                  <div>Chọn loại ticket <span style="color: red">*</span></div>
                </template>
              </v-autocomplete>
            </validation-provider>
          </v-col>
        </v-row>
        <v-row class="mb-5">
          <v-col cols="12" md="12" sm="12">
            <validation-provider
              v-slot="{ errors }"
              class="mb-2"
              :rules="{ required: true }"
              name="Chi tiết"
            >
              <v-textarea
                v-model="dataForm.content"
                :error-messages="errors"
                label="Chi tiết yêu cầu *"
                color="primary"
                placeholder="Nhập chi tiết yêu cầu..."
                rows="5"
                auto-grow
                clearable
                :maxlength="500"
              >
                <template slot="label">
                  <div>Chi tiết yêu cầu <span style="color: red">*</span></div>
                </template>
              </v-textarea>
            </validation-provider>
          </v-col>
        </v-row>

        <v-row class="mb-5">
          <v-col cols="12" md="12" sm="12">
            <div class="mb-5">Đính kèm( ảnh/video)</div>

            <v-file-input
              class="placeholder"
              :key="componentKey"
              id="fileAttachment"
              v-model="file"
              accept="image/*, video/*"
              label="Chọn file đính kèm"
              @change="changeFiles"
            ></v-file-input>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="group-btn--form create-support-btn-container">
        <v-btn
          color="#FA1E95"
          class="create-support-btn"
          @click.prevent="handleSubmit(showFormConfirm)"
          >Gửi hỗ trợ</v-btn
        >
      </v-card-actions>
    </validation-observer>
    <v-dialog v-if="dialogConfirmSupport" content-class="dialog-waiting" class="text-center p-3" v-model="dialogConfirmSupport" width="400">
        <template>
          <div
              style="
          background-color: #fff;
          padding: 20px;
          min-height: 200px;
          ">
            <svg
                class="float-left ml-2" width="68" height="68" viewBox="0 0 68 68" fill="none"
                xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M37.4 23.8H30.6V17H37.4M37.4 51H30.6V30.6H37.4M34 0C29.5351 0 25.1138 0.879436 20.9888 2.5881C16.8637 4.29676 13.1156 6.80118 9.95837 9.95837C3.58213 16.3346 0 24.9826 0 34C0 43.0174 3.58213 51.6654 9.95837 58.0416C13.1156 61.1988 16.8637 63.7033 20.9888 65.4119C25.1138 67.1206 29.5351 68 34 68C43.0174 68 51.6654 64.4179 58.0416 58.0416C64.4179 51.6654 68 43.0174 68 34C68 29.5351 67.1206 25.1138 65.4119 20.9888C63.7033 16.8637 61.1988 13.1156 58.0416 9.95837C54.8844 6.80118 51.1363 4.29676 47.0112 2.5881C42.8862 0.879436 38.4649 0 34 0Z"
                  fill="#0088FF"/>
            </svg>
            <div
              class="text-2 float-right w-75 ml-2"
            >
              <p>Mã khách hàng: {{ dataForm.customerCode }}</p>
              <p class="ma-0">Nhóm: {{ dataForm.ticketGroupId.name }}</p>
              <p class="">Loại: {{ dataForm.ticketTypeId.ticketTypeName }}</p>
              <p>Nhấn xác nhận thông tin để tạo hỗ trợ.</p>
              <div class="group-btn">
                <v-btn color="#0088ff" class="ma-0 mr-2" @click="createRequest"
                  >Xác nhận</v-btn
                >
                <v-btn
                  color="btn-cancel"
                  class="ma-0 mr-2"
                  @click="dialogConfirmSupport = false"
                  >Hủy</v-btn
                >
              </div>
            </div>
          </div>
        </template>
      </v-dialog>
  </div>
</template>

<script>
import { MAX_SIZE_FILE_UPLOAD, regex } from "@/helpers/constants";
import TokenService from "@/helpers/token";
import * as moment from "moment";
import RepositoryFactory from "../../../repositories/RepositoryFactory";
const SupportRepository = RepositoryFactory.get("support");
const ImageRepository = RepositoryFactory.get("image");

export default {
  props: {
    mobileStyle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dialogConfirmSupport: false,
      regex,
      mobile: "",
      ticketsChild: [],
      groupTickes: [],
      groupTickesClone: [],
      descriptionRequest: "",
      request: "",
      urgentRequest: "",
      urgentList: [],
      file: undefined,
      urlFileAttachment: "",
      typeFileAttachment: "",
      stringBase64: "",
      componentKey: 0,
      dataForm: {},
      ticketTypeNames: [],
      limitLangeCustomerCode:15
    };
  },
  created() {
    // this.getUrgentList()
    this.getGroupTickets();
    this.dataForm.customerCode = this.$route.query?.code;
  },
  watch: {

  },
  methods: {
    clearSpace(){
      this.dataForm.customerCode = this.dataForm.customerCode.trim();
      this.limitLangeCustomerCode = 10
      if(!this.dataForm.customerCode){
        this.limitLangeCustomerCode = 15
      }
    },
    onChangeTicketGroup(){
      this.dataForm.ticketTypeId = null;
      this.ticketTypeNames = [];
      if (!this.dataForm.ticketGroupId) {
        this.ticketTypeNames = [];
        return;
      }
      this.ticketTypeNames = this.groupTickesClone.filter(
        (item) => item.id == this.dataForm.ticketGroupId.id
      )[0].TicketGroupType;
    },
    showFormConfirm() {
      this.dialogConfirmSupport = true;
    },
    async createRequest() {
      this.dialogConfirmSupport = false;
      const user = TokenService.getUser();
      let payload = {
        obj: "tickets",
        data: {
          customerCode: this.dataForm.customerCode.trim(),
          ticketGroupName: this.dataForm.ticketGroupId.name,
          ticketGroupId: this.dataForm.ticketGroupId.id,
          ticketTypeId: this.dataForm.ticketTypeId.ticketTypeId,
          ticketTypeName: this.dataForm.ticketTypeId.ticketTypeName,
          priority: this.dataForm.ticketTypeId.priority,
          content: this.dataForm.content?.trim(),
          media: this.dataForm.fileUrl || null,
          status:1,
          statusName:'Mới',
          createdBy: user.id,
          updatedBy: user.id,
          createdName: user.username,
        },
      };
      let res = await SupportRepository.fgApiSet(payload);
      if (res.success) {
        this.$swal({
          type: "success",
          icon: "success",
          title: "Tạo phiếu hỗ trợ thành công",
        });
        this.dataForm = {};
        this.file = null;
        this.$refs.validator.reset();
        this.limitLangeCustomerCode = 15
      } else {
        this.$swal({
          type: "error",
          icon: "error",
          title: "Tạo phiếu trợ thất bại",
        });
      }
    },
    async getGroupTickets() {
      let res = await SupportRepository.getGroupTickets();
      if (res.success) {
        this.groupTickes = _.get(res, "data", []);
        this.groupTickesClone = _.cloneDeep(this.groupTickes);
        this.groupTickes = this.groupTickes.map((item) => {
          return {
            id: item.id,
            name: item.name,
          };
        });
      }
    },
    async changeFiles () {
      if(this.file) {
        let checkError = false;
        if (this.file.size > MAX_SIZE_FILE_UPLOAD) {
          checkError = true;
          this.file = null;
          this.componentKey ++
        }
        if (checkError) {
          this.urlFileAttachment = '';
          this.typeFileAttachment = '';
          this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: 'Không thể tải file lớn hơn 5 MB !'
          });
          return
        }
        this.getBase64(this.file).then(
            data => {
              this.uploadFile(data);
            }
        );
      } else {
        this.urlFileAttachment = '';
        this.typeFileAttachment = '';
      }
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(
            reader.result
                .replace("data:", "")
                .replace(/^.+,/, "")
        );
        reader.onerror = error => reject(error);
      });
    },
    async uploadFile(data) {
      const currentDate = moment().format("DD-MM-YYYY-HH-mm-ss");
      const fileName = this.file.name.trim()?.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
          .replace(/đ/g, "d")
          .replace(/Đ/g, "D")
          .replace(/ /g, '_');
      const file = {
        name: currentDate + '_' + fileName,
        content: data,
        size: this.file.size,
        type: this.file.type
      }

      this.loading = this.$loading.show()
      const response = await SupportRepository.uploadImage(file)
      this.loading.hide()
      if (response.success) {
        this.$swal({
          type: "success",
          icon: "success",
          text: "Tải file lên thành công",
        });
        this.dataForm.fileUrl = response.data.url;
      } else {
        this.$swal({
          type: "error",
          icon: "error",
          text: "Tải file lên thất bại",
        });
      }
    }
  },
};
</script>

<style scoped>
.create-support-btn-container {
  max-width: 100% !important;
  width: 100%;
  padding: 10px !important;
  position: fixed;
  bottom: 5px;
  z-index: 10;
}

/deep/.v-select-list {
  max-height: 250px;
  overflow-y: auto;
  font-size: 16px;
}

/deep/.v-list-item {
  min-height: 30px;
}

/deep/input,
/deep/textarea {
  font-size: 16px !important;
}

/deep/.v-label {
  font-size: 16px !important;
}

/deep/.v-messages {
  font-size: 14px !important;
}
</style>
<style lang="scss">
.form-support-v2 {
  input::placeholder,
  textarea::placeholder,
  .placeholder {
    font-weight: 400;
    font-size: 14px;
    font-style: italic;
  }
}
.dialog-waiting{
  background-color: #fff;
  padding-bottom: 10px;
  ul {
    padding-left: 16px !important;
  }
}
.float-right {
  max-width: 250px;
}
</style>
